import {createEntityAdapter} from '@reduxjs/toolkit';
import {Area} from '../entities';

export const areasAdapter = createEntityAdapter<Area>({
  selectId: (area) => area.id,
  sortComparer: (a1, a2) => a1.name.localeCompare(a2.name),
});
